// api/ApiAuth.ts

import {
    ApiResponse,
    TokenResponse,
    RegisterResponse,
    VerificationTokenResponse,
    RefreshTokenResponse,
    VerifyCodeResponse,
    TryPasswordResetResponse,
    PasswordResetResponse,
    LogoutResponse,
    GenerateReferralResponse
} from './ApiResponse';
import {
    GenerateTokenRequest,
    LogoutRequest,
    PasswordResetRequest, RefreshTokenRequest,
    RegisterRequest, TokenRequest,
    TryPasswordResetRequest, VerificationTokenRequest,
    VerifyCodeRequest
} from './ApiRequest';
import axios, {Method} from 'axios';
const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001/api';

export async function apiRequest<T>(
    url: string,
    method: Method = 'POST',
    body?: any
): Promise<ApiResponse<T>> {
    try {
        const response = await axios.request<ApiResponse<T>>({
            url,
            method,
            data: body,
            headers: { 'Content-Type': 'application/json' },
        });
        return response.data;
    } catch (error: any) {
        const response = error.response;
        return {
            error: response?.data?.error || 'player-notification-server-error',
            message: response?.data?.message || '',
            statusCode: response?.status || 500,
        };
    }
}

export const getTokenFromServer = async (body: TokenRequest): Promise<ApiResponse<TokenResponse>> => {
    return await apiRequest<TokenResponse>(
        `${API_URL}/login`,
        'POST',
        body
    );
}

export const verifyAccessToken = async (body: VerificationTokenRequest): Promise<ApiResponse<VerificationTokenResponse>> => {
    return await apiRequest<VerificationTokenResponse>(
        `${API_URL}/verification-token`,
        'POST',
         body
    );
};

export const refreshAccessToken = async (body: RefreshTokenRequest): Promise<ApiResponse<RefreshTokenResponse>> => {
    return await apiRequest<RefreshTokenResponse>(
        `${API_URL}/refresh-token`,
        'POST',
        body
    );
};

export const sendRegisterRequest = async (body: RegisterRequest): Promise<ApiResponse<RegisterResponse>> => {
    return await apiRequest<RegisterResponse>(
        `${API_URL}/register`,
        'POST',
        body
    );
};

export const sendVerifyCodeRequest = async (
    body: VerifyCodeRequest
): Promise<ApiResponse<VerifyCodeResponse>> => {
    return await apiRequest<VerifyCodeResponse>(
        `${API_URL}/verify-code`,
        'POST',
        body
    );
};

export const tryPasswordResetRequest = async (
    body: TryPasswordResetRequest
): Promise<ApiResponse<TryPasswordResetResponse>> => {
    return await apiRequest<TryPasswordResetResponse>(
        `${API_URL}/request-password-reset`,
        'POST',
        body
    );
};

export const resetPasswordRequest = async (
    body: PasswordResetRequest
): Promise<ApiResponse<PasswordResetResponse>> => {
    return await apiRequest<PasswordResetResponse>(
        `${API_URL}/reset-password`,
        'POST',
        body
    );
};

export const logoutRequest = async (body: LogoutRequest): Promise<ApiResponse<LogoutResponse>> => {
    return await apiRequest<LogoutResponse>(
        `${API_URL}/logout`,
        'POST',
        body
    );
};

export const generateReferralId = async (body: GenerateTokenRequest): Promise<ApiResponse<GenerateReferralResponse>> => {
    return await apiRequest<GenerateReferralResponse>(
        `${API_URL}/generate-referral`,
        'POST',
        body
    );
};

